import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["option"];
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Media, MediaLeft, MediaBody } from 'foundations-components/transitional/components/Media';
import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import AssetThumbnail from 'personalization-lib/components/thumbnail/AssetThumbnail';
import VariantInfo from 'personalization-lib/components/shared/display/VariantInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantSelectOption = _ref => {
  var _option$assetData;
  let {
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Clickable, Object.assign({}, rest, {
    title: option.text,
    "data-test-id": "variant-select-option",
    children: /*#__PURE__*/_jsxs(Media, {
      paddingBlock: "200",
      paddingInline: "500",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(AssetThumbnail, {
          imgSrc: (_option$assetData = option.assetData) === null || _option$assetData === void 0 ? void 0 : _option$assetData.imgSrc,
          inlineSize: "65px",
          maxBlockSize: "40px",
          borderRadius: "200",
          borderWidth: "100",
          borderColor: "border-core-default",
          borderStyle: "solid"
        })
      }), /*#__PURE__*/_jsx(MediaBody, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "100",
          children: [/*#__PURE__*/_jsx(TruncateString, {
            children: option.text
          }), /*#__PURE__*/_jsx(VariantInfo, {
            segmentIdentifier: option.segmentIdentifier,
            targetingState: option.assetData.targetingState,
            publishStatus: option.assetData.publishStatus,
            loading: option.loading,
            error: option.error
          })]
        })
      })]
    })
  }));
};
export default VariantSelectOption;